import { request } from './repository';

const url = 'organization-categories/';

const organizationCategoryRepository = {
    getOrganizationCategories(params) {
        return request.get(url, params);
    },
    storeOrganizationCategory(data) {
        return request.post(url, data);
    },
    updateOrganizationCategory(id, data) {
        return request.put(url + id, data);
    },
    deleteOrganizationCategory(id) {
        return request.delete(url + id);
    }
}

export default organizationCategoryRepository;